import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=0d91beaa&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d91beaa')) {
      api.createRecord('0d91beaa', component.options)
    } else {
      api.reload('0d91beaa', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=0d91beaa&", function () {
      api.rerender('0d91beaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUqyg5wWuhI0/JS/imageCarousel.vue"
export default component.exports